<div class="flex flex-col sm:flex-row justify-center gap-6 max-w-[70rem]">
  <p-card>
    <div class="flex flex-col items-center gap-4 justify-between h-[60vh] w-[80vw]
           sm:h-[70vh] sm:w-[25vw]  md:h-[400px]  p-1 lg:p-4">
      <img alt="Sisdemanda" height="98" ngSrc="logo.png" width="300"/>
      <p class="text-sm text-center break-words font-[Rawline] leading-relaxed">
        Acesse sua conta gov.br para criar ou reforçar uma demanda já existente.
      </p>
      <button (click)="onLoginGov()" class="button-govbr w-full">
        <app-icon-user-govbr/>
        Entrar com gov.br
      </button>
    </div>
  </p-card>

  <p-card>
    <div class="flex flex-col items-center gap-4 justify-between h-[60vh] w-[80vw]
           sm:h-[70vh] sm:w-[25vw] md:h-[400px] p-1 lg:p-4">
      <img alt="Sisdemanda" height="98" ngSrc="logo.png" width="300"/>
      <p class="text-sm text-center break-words font-[Rawline] leading-relaxed">
        Para Concessionárias e Representações, acesse via Token.
      </p>
      <button (click)="onLoginConcessionarias()" class="button-govbr button-govbr--gray w-full">
        <app-icon-key [size]="15"/>
        Entrar com token
      </button>
    </div>
  </p-card>
</div>
